import { useContext } from 'react';
import { CvtDispatchContext, CvtStateContext, GetCVTParams } from './cvt.context';
import { CvtService } from './cvt.service';
import { fetchCvtList, deleteCvt, clearCvtErrors } from './cvt.context';
import { GetCVTsResponse } from '@packages/models/api/cvt';

export const useCvtState = () => {
    const state = useContext(CvtStateContext);

    if (state === undefined) {
        throw new Error('useCvtState must be used within a CvtProvider');
    }

    return state;
};

export const useCvtDispatch = () => {
    const dispatch = useContext(CvtDispatchContext);

    if (dispatch === undefined) {
        throw new Error('useCvtDispatch must be used within a CvtProvider');
    }

    return dispatch;
};

export const useCvt = (cvtService: CvtService) => {
    const state = useCvtState();
    const dispatch = useCvtDispatch();

    return {
        state,
        dispatch,
        fetchCvtList: (vin?: string, params?: GetCVTParams | string, skipLoading?: boolean) => {
            if (!vin) {
                return;
            }
            return fetchCvtList(dispatch, cvtService, vin, params, skipLoading);
        },
        deleteCvt: (diagnosticId: string) => {
            const currentList = state.cvtList;
            return deleteCvt(dispatch, cvtService, diagnosticId, currentList as GetCVTsResponse);
        },

        clearErrors: () => clearCvtErrors(dispatch),
    };
};
